import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle } from "lucide-react";
import React from "react";

const benefits = [
  "Essai gratuit de 14 jours",
  "Accès à toutes les fonctionnalités",
  "Support client dédié",
  "Aucun engagement",
];

export default function MiniFooter() {
  return (
    <section className="py-20 bg-slate-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          Prêt à transformer votre pratique juridique ?
        </h2>
        <p className="text-xl text-slate-100 mb-8 max-w-2xl mx-auto">
          Rejoignez les milliers de professionnels qui utilisent déjà
          Docuveritas pour optimiser leurs recherches juridiques quotidiennes.
        </p>

        <div className="flex flex-wrap justify-center gap-6 mb-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="flex items-center space-x-2 text-slate-100"
            >
              <CheckCircle className="h-5 w-5 text-green-400" />
              <span>{benefit}</span>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Button
            size="lg"
            className="bg-white text-slate-500 hover:bg-gray-100 px-8 py-4 text-lg rounded-xl"
          >
            Commencer l'essai gratuit
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
          <Button
            size="lg"
            variant="outline"
            className="border-2 border-white text-white hover:bg-white hover:text-slate-500 px-8 py-4 text-lg rounded-xl bg-transparent"
          >
            Planifier une démo
          </Button>
        </div>

        <p className="text-slate-200 text-sm">
          Questions ? Contactez notre équipe au{" "}
          <a href="tel:+33123456789" className="text-white hover:underline">
            01 23 45 67 89
          </a>{" "}
          ou par{" "}
          <a
            href="mailto:contact@docuveritas.com"
            className="text-white hover:underline"
          >
            email
          </a>
        </p>
      </div>
    </section>
  );
}
